import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/PageHeader";
import AdminChurches from "@/components/admin/AdminChurches";
import AdminUsers from "@/components/admin/AdminUsers";
import AdminLists from "@/components/admin/AdminLists";
import AdminEvents from "@/components/admin/AdminEvents";
import AdminSettings from "@/components/admin/AdminSettings";
import AdminContent from "@/components/admin/AdminContent";
import AdminFinance from "@/components/admin/AdminFinance";
import AdminExport from "@/components/admin/AdminExport";
import { useApp } from "@/context/AppContext";

const TABS = [
  ["churches", "Churches", AdminChurches, "churches"],
  ["users", "Users & Logins", AdminUsers, "users"],
  ["lists", "Categories & Lists", AdminLists, "settings"],
  ["events", "Conference Events", AdminEvents, "conference"],
  ["settings", "Toggles & Permissions", AdminSettings, "settings"],
  ["finance", "Financial Report", AdminFinance, "finance"],
  ["content", "Page Content Editor", AdminContent, "content"],
  ["export", "Export Data", AdminExport, "export"],
];

export default function Admin() {
  const { hasArea, user, feat } = useApp();
  const tabs = TABS.filter((t) => (t[0] !== "export" || feat("export_data")) && (hasArea(t[3]) || (t[0] === "users" && user?.can_reset)));
  return (
    <div>
      <PageHeader eyebrow="Master Admin" title="Admin Panel" subtitle="Manage churches, logins, lists, events and what everyone can see." />
      <Tabs defaultValue={tabs.find((t) => t[0] === new URLSearchParams(window.location.search).get("tab"))?.[0] || tabs[0]?.[0]}>
        <TabsList className="mb-6 h-auto flex-wrap justify-start gap-1 bg-white p-1 shadow-sm ring-1 ring-slate-200">
          {tabs.map(([k, l]) => (
            <TabsTrigger key={k} value={k} className="px-4 py-2 text-sm font-semibold data-[state=active]:bg-[hsl(var(--primary))] data-[state=active]:text-white" data-testid={`admin-tab-${k}`}>{l}</TabsTrigger>
          ))}
        </TabsList>
        {tabs.map(([k, , C]) => <TabsContent key={k} value={k}><C /></TabsContent>)}
      </Tabs>
    </div>
  );
}
